import { createRoot } from "react-dom/client";
import "./index.css";
import EmcSection from "./App.jsx";

function initEmcSection() {
  const container = document.getElementById("emc-root");
  if (container) {
    const root = createRoot(container);
    root.render(<EmcSection />);
  } else {
    console.warn("EMC section container #emc-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initEmcSection);
} else {
  initEmcSection();
}
